import { useGetIsFormDisabled } from '..';
import { Values } from '../../composer-env';

const useIsFormDisabled = (values: Values) => {
  const getIsFormDisabled = useGetIsFormDisabled();
  const isDisabled = getIsFormDisabled(values);

  return isDisabled;
};

export default useIsFormDisabled;
